import {
  SAVE_TEXT_ALERT_SETTINGS_SUCCESS, SAVE_TEXT_ALERT_SETTINGS_ERROR,
  SAVE_TEXT_ALERT_SETTINGS_LOADING, TEXT_ALERT_SETTINGS_LOADING, TEXT_ALERT_SETTINGS_ERROR, TEXT_ALERT_SETTINGS_SUCCESS,
} from 'constants/ActionTypes';
import { t } from 'i18next';
import {
  all, call, put, select,
} from 'lib/redux';
import getMobileProvidersService from 'services/getMobileProviders.service';
import getTextAlertMessagesService from 'services/getTextAlertMessages.service';
import getTextAlertPreferencesService from 'services/getTextAlertPreferences.service';
import saveTextAlertPreferencesService from 'services/saveTextAlertPreferences.service';
import { scrollToTop, trackUserEvent } from 'utils/app.utils';
import { validatePhoneNumber } from 'utils/validation.util';
import { logError } from 'utils/logger.utils';
import { USER_EVENTS } from 'constants/AppConstants';

export default function* loadTextAlertSettingsSaga() {
  try {
    yield put({ type: TEXT_ALERT_SETTINGS_LOADING });
    const responses = yield all([
      call(getTextAlertPreferencesService),
      call(getMobileProvidersService),
      call(getTextAlertMessagesService),
    ]);
    if (responses.some(({ ok }) => !ok)) {
      const { error } = responses.find(({ ok }) => !ok);
      throw error;
    }
    const [textAlertPreferences, mobileProviders, textAlerts] = responses.map(({ json }) => json);
    yield put({
      type: TEXT_ALERT_SETTINGS_SUCCESS, textAlertPreferences, mobileProviders, textAlerts,
    });
  } catch (error) {
    yield put({ type: TEXT_ALERT_SETTINGS_ERROR });
    logError('Error in loadTextAlertSettingsSaga', {
      error: error?.message,
      errorCode: error?.errorCode,
    });
  }
}

export function* saveTextAlertSettingsSaga() {
  try {
    trackUserEvent(USER_EVENTS.SAVE_TEXT_ALERT_PREFERENCES);
    yield put({ type: SAVE_TEXT_ALERT_SETTINGS_LOADING });

    const { textAlertPreferences, updatedTextAlertPreferences } = yield select(({ textAlertSettings }) => textAlertSettings);

    const requestBody = { ...textAlertPreferences, ...updatedTextAlertPreferences };
    if (requestBody?.mobileProviderId === 0) {
      yield put({ type: SAVE_TEXT_ALERT_SETTINGS_ERROR, errors: t('select_phone_provider') });
      return;
    }
    if (requestBody?.mobileNumber?.length !== 0
       && !validatePhoneNumber(requestBody.mobileNumber)) {
      yield put({ type: SAVE_TEXT_ALERT_SETTINGS_ERROR, errors: t('common__invalid_phone_number') });
      return;
    }
    const response = yield call(saveTextAlertPreferencesService, requestBody);
    if (!response.ok) {
      const error = new Error(response.json.errorDescription);
      error.errorCode = response.json.errorCode;
      throw error;
    }
    yield put({ type: SAVE_TEXT_ALERT_SETTINGS_SUCCESS, textAlertPreferences: response.json });
    scrollToTop();
  } catch (error) {
    yield put({ type: SAVE_TEXT_ALERT_SETTINGS_ERROR });
    scrollToTop();
  }
}
